import type { TOC } from '@ember/component/template-only';

import safeStyle from 'webapp/helpers/safe-style';
import CommonUiIcon from 'webapp/components/common/ui-icon';
import ToolTip from 'webapp/components/tool-tip';

interface ReportsEditorSlideOverflowLineComponentInterface {
	Args: {
		bgColor: string;
	};
}

const ReportsEditorSlideOverflowLineComponent: TOC<ReportsEditorSlideOverflowLineComponentInterface> =
	<template>
		<div class="overflow-line hidden">
			<em class="square-plus" style={{safeStyle @bgColor property="background-color"}}>
				<CommonUiIcon @name="Plus" @size="xs" />
			</em>
			<ToolTip
				@text="The text below this line will not be visible when the report is exported to PDF."
				@maxWidth={{250}}
			/>
		</div>
	</template>;

export default ReportsEditorSlideOverflowLineComponent;
